import {DatePipe, DecimalPipe, registerLocaleData} from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import localeUk from '@angular/common/locales/uk';
import {APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RouterModule} from '@angular/router';
import {ServiceWorkerModule} from '@angular/service-worker';
import {ClarityModule, ClrDropdownModule} from '@clr/angular';
import {AkitaNgRouterStoreModule} from '@datorama/akita-ng-router-store';
import {AkitaNgDevtools} from '@datorama/akita-ngdevtools';
import {environment} from '@env/environment';
import {HasRoleModule} from './_shared/directives/has-role/has-role.module';
import {AppComponent} from './app.component';
import {AppRoutes} from './app.routes';
import {HeaderComponent} from './components/header/header.component';
import {NotificationsDropdownComponent} from './components/notifications-dropdown/notifications-dropdown.component';
import {WorkContainerComponent} from './components/work-container/work-container.component';
import {LoadingInterceptor} from './services/loading.interceptor';
import {PageService} from './state/page/page.service';
import {ActionsDropdownComponent} from './components/actions-dropdown/actions-dropdown.component';
import {PowerBiModalComponent} from './components/power-bi-modal/power-bi-modal.component';
import {KeycloakService} from 'keycloak-angular';
import {initializer} from './services/app.initializer';
import {SessionQuery, SessionService, SessionStore} from './_shared/modules/agri-auth/state/session';
import {CookieService} from 'ngx-cookie-service';
import {AuthRedirectService} from './_shared/modules/agri-auth/services/auth-redirect.service';
import {AuthInterceptor} from './_shared/modules/agri-auth/services/auth.interceptor';
import {AuthGuard} from './_shared/modules/agri-auth/services/auth.guard';
import {TokenRefreshService} from './_shared/modules/agri-auth/services/token-refresh.service';
import { ClickOutsideModule } from './_shared/directives/click-outside/click-outside.module';
import { GlobalErrorHandler } from './services/global-error-handler';
import { DatePickerOverlayComponent } from './app/_shared/components/date-picker-overlay/date-picker-overlay.component';
import {ClarityIconsService} from './services/clarity-icons.service';
import {AccessDeniedModalComponent} from './_shared/components/access-denied-modal/access-denied-modal.component';

// the second parameter 'fr' is optional
registerLocaleData(localeUk, 'uk');

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes),
    ReactiveFormsModule,
    // todo: remove devtools for production
    // environment.production ? [] : AkitaNgDevtools.forRoot(),
    AkitaNgDevtools.forRoot(),
    AkitaNgRouterStoreModule.forRoot(),
    HttpClientModule,
    // ServiceWorkerModule.register('ngsw-worker.js', {enabled: environment.production}),
    ClrDropdownModule,
    HasRoleModule,
    // AgriAuthModule.forRoot({
    //   apiRoot: environment.apiRoot,
    //   authServerUrl: environment.authServerUrl,
    //   workerRoot: environment.workerRoot
    // }),
    ClarityModule,
    ClickOutsideModule,
  ],
  declarations: [
    AppComponent,
    HeaderComponent,
    WorkContainerComponent,
    NotificationsDropdownComponent,
    ActionsDropdownComponent,
    PowerBiModalComponent,
    DatePickerOverlayComponent,
    AccessDeniedModalComponent
  ],
  entryComponents: [AccessDeniedModalComponent],
  bootstrap: [AppComponent],
  providers: [
    KeycloakService,
    SessionQuery,
    SessionService,
    SessionStore,
    AuthRedirectService,
    CookieService,
    AuthGuard,
    TokenRefreshService,
    DecimalPipe,
    DatePipe,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingInterceptor,
      multi: true,
      deps: [PageService]
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initializer,
      deps: [KeycloakService, SessionService, TokenRefreshService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (clarityIconsService: ClarityIconsService) => () => clarityIconsService.addIcons(),
      deps: [ClarityIconsService],
      multi: true,
    },
    {
      provide: LOCALE_ID,
      useValue: 'uk'
    }
  ]
})
export class AppModule {
}
